import axios from 'lib/apiClient';

export const getCategories = (params) =>
  axios.get(`API/1_0/categories.php`, {
    params,
  });

export const saveCategory = (data) =>
  axios.post(`API/1_0/categories.php`, data);

export const deleteCategory = (hash) =>
  axios.delete(`API/1_0/categories.php`, {
    params: { hash },
  });

export const getCategoryItems = (params) =>
  axios.get(`API/1_0/categoryItems.php`, {
    params,
  });

export const addCategoryItem = (object_id, category_id) =>
  axios.post(`API/1_0/categoryItems.php`, { object_id, category_id });

export const saveCategoryItem = (data) =>
  axios.post(`API/1_0/categoryItems.php`, data);

export const deleteCategoryItem = (hash) =>
  axios.delete(`API/1_0/categoryItems.php`, {
    params: { hash },
  });
